<div [ngClass]="dialogBox ? 'dialog-box card' : ''">
  @if (dialogBox) {
    <div class="card-header">
      Schedule
      <span class="float-end" (click)="onCloseDialogue()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
  }
  <div>
    <form [formGroup]="schedulerForm" appFormEnterAction>
      @if (!["schedule"].includes(shownFrom)) {
        <div class="form-check d-flex gap-2 ms-3 align-items-center">
          <input
            class="form-check-input cursor-pointer"
            type="checkbox"
            id="repeatCheckbox"
            (change)="
              showRecurringView ? cancelRecuringView() : makeRecuringView()
            "
            [checked]="showRecurringView"
          />
          <label class="form-check-label cursor-pointer" for="repeatCheckbox">
            Repeat / Recurring
          </label>
        </div>
      }
      @if (!showRecurringView) {
        <div
          class="d-flex flex-wrap row-gap-2 column-gap-4"
          [class.mb-4]="shownFrom != 'schedule'"
        >
          @if (schedulerFields.startDateTime.showInput) {
            <div class="form-floating flex-grow-1">
              <input
                id="startDay"
                class="form-control"
                type="datetime-local"
                placeholder="Pick Date & Time"
                (blur)="schedulerFields.startDateTime.showInput = false"
                [(ngModel)]="startDateTime"
                [ngModelOptions]="{ standalone: true }"
                (input)="changeStartDateTime($event)"
                (change)="changeStartDateTime($event)"
                [min]="validStartDateTime"
                [class.is-invalid]="schedulerForm.controls['start_day'].invalid"
              /><label for="startDay">
                {{ schedulerFields.startDateTime.header }}</label
              >
            </div>
          } @else {
            <dl class="p-3 mb-0">
              <dt>
                {{ schedulerFields.startDateTime.header }}
              </dt>
              <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                {{ startDateTime | customDate: "d MMM y HH:mm" }}
                <span
                  class="ms-2 edit-button"
                  (click)="focusField('startDateTime')"
                ></span>
              </dd>
            </dl>
          }

          @if (schedulerFields.endDateTime.showInput) {
            <div class="form-floating flex-grow-1">
              <input
                id="endDay"
                type="datetime-local"
                class="form-control"
                placeholder="Pick Date & Time"
                (blur)="schedulerFields.endDateTime.showInput = false"
                [(ngModel)]="endDateTime"
                [disabled]="!startDateTime"
                [min]="startDateTime"
                [max]="endDateTimeMax"
                [ngModelOptions]="{ standalone: true }"
                (input)="changeEndDateTime($event)"
                (change)="changeEndDateTime($event)"
                [class.is-invalid]="schedulerForm.controls['end_day'].invalid"
              /><label for="endDay">
                {{ schedulerFields.endDateTime.header }}</label
              >
            </div>
          } @else {
            <dl class="p-3 mb-0">
              <dt>
                {{ schedulerFields.endDateTime.header }}
              </dt>
              <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                {{ endDateTime | customDate: "d MMM y HH:mm" }}
                <span
                  class="ms-2 edit-button"
                  (click)="focusField('endDateTime')"
                ></span>
              </dd>
            </dl>
          }

          @if (schedulerForm.value | misc: "getTimeDifference") {
            <dl class="p-3 mb-0">
              <dt>Duration (HH:MM)</dt>
              <dd>
                {{ schedulerForm.value | misc: "getTimeDifference" }}
              </dd>
            </dl>
          }
        </div>
      }
      @if (showRecurringView) {
        <div class="row row-cols-2 g-2" [class.mb-4]="shownFrom != 'schedule'">
          <div class="col-12">
            <div class="d-flex flex-wrap row-gap-0 column-gap-4">
              @if (schedulerFields.startDay.showInput) {
                <div class="form-floating flex-grow-1">
                  <input
                    type="date"
                    id="startDay"
                    class="form-control"
                    placeholder="Start Date"
                    (blur)="schedulerFields.startDay.showInput = false"
                    formControlName="start_day"
                    [min]="validStartDate"
                    [class.is-invalid]="
                      schedulerForm.controls['start_day'].invalid
                    "
                    (input)="validateEndDay()"
                    (change)="validateEndDay()"
                  />
                  <label for="startDay" class="form-label">
                    {{ schedulerFields.startDay.header }}</label
                  >
                </div>
              } @else {
                <dl class="p-3 mb-0">
                  <dt>
                    {{ schedulerFields.startDay.header }}
                  </dt>
                  <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                    {{ schedulerForm.value.start_day | customDate: "d MMM y" }}
                    <span
                      class="ms-2 edit-button"
                      (click)="focusField('startDay')"
                    ></span>
                  </dd>
                </dl>
              }
              @if (schedulerFields.startTime.showInput) {
                <div class="form-floating flex-grow-1">
                  <input
                    type="time"
                    class="form-control"
                    id="startTime"
                    (blur)="schedulerFields.startTime.showInput = false"
                    placeholder="Start Time"
                    (input)="validateEndTime()"
                    (change)="validateEndTime()"
                    formControlName="start_time"
                  />
                  <label for="startTime" class="form-label">
                    {{ schedulerFields.startTime.header }}</label
                  >
                </div>
              } @else {
                <dl class="p-3 mb-0">
                  <dt>
                    {{ schedulerFields.startTime.header }}
                  </dt>
                  <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                    {{ schedulerForm.value.start_time }}
                    <span
                      class="edit-button ms-2"
                      (click)="focusField('startTime')"
                    ></span>
                  </dd>
                </dl>
              }
              @if (schedulerFields.endTime.showInput) {
                <div class="form-floating flex-grow-1">
                  <input
                    class="form-control"
                    placeholder="End Time"
                    id="endTime"
                    (blur)="schedulerFields.endTime.showInput = false"
                    formControlName="end_time"
                    (input)="validateEndTime()"
                    (change)="validateEndTime()"
                    type="time"
                  /><label for="endTime">
                    {{ schedulerFields.endTime.header }}</label
                  >
                </div>
              } @else {
                <dl class="p-3 mb-0">
                  <dt>
                    {{ schedulerFields.endTime.header }}
                  </dt>
                  <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                    {{ schedulerForm.value.end_time }}
                    <span
                      class="edit-button ms-2"
                      (click)="focusField('endTime')"
                    ></span>
                  </dd>
                </dl>
              }

              @if (schedulerForm.value | misc: "getTimeDifference") {
                <dl class="p-3 mb-0">
                  <dt>Duration (HH:MM)</dt>
                  <dd>
                    {{ schedulerForm.value | misc: "getTimeDifference" }}
                  </dd>
                </dl>
              }

              @if (schedulerFields.endDay.showInput) {
                <div class="form-floating flex-grow-1">
                  <input
                    type="date"
                    class="form-control"
                    id="endDay"
                    placeholder="End Date"
                    (blur)="schedulerFields.endDay.showInput = false"
                    [min]="validateEndDate"
                    formControlName="end_day"
                    (input)="validateEndTime()"
                    (change)="validateEndTime()"
                    [max]="validEndDateMax"
                    [class.is-invalid]="
                      schedulerForm.controls['end_day'].invalid
                    "
                  />
                  <label for="endDay">
                    {{ schedulerFields.endDay.header }}</label
                  >
                </div>
              } @else {
                <dl class="p-3 mb-0">
                  <dt>
                    {{ schedulerFields.endDay.header }}
                  </dt>
                  <dd [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'">
                    {{ schedulerForm.value.end_day | customDate: "d MMM y" }}
                    <span
                      class="edit-button ms-2"
                      (click)="focusField('endDay')"
                    ></span>
                  </dd>
                </dl>
              }
            </div>
          </div>

          <!-- Recurring Event Details -->
          <!-- Iterate over each option -->
          <div class="text-center col-12 py-2">
            @for (option of repeatTypes; track option) {
              <div class="form-check form-check-inline">
                <!-- Bootstrap class for inline radio buttons -->
                <input
                  class="form-check-input"
                  type="radio"
                  name="repeat_type"
                  id="{{ option.value }}"
                  [value]="option.value"
                  formControlName="repeat_type"
                  [(ngModel)]="selectedRepeatType"
                  (change)="onRepeatTypeChange(option.value)"
                />
                <label class="form-check-label" for="{{ option.value }}">
                  {{ option.label }}
                </label>
              </div>
            }
          </div>
          @if (
            selectedRepeatType === "daily" ||
            selectedRepeatType === "weekly" ||
            selectedRepeatType === "monthly"
          ) {
            <div class="col-12 text-center py-2">
              <div class="d-flex align-items-center justify-content-evenly g-2">
                <div>Repeat every</div>
                <div class="w-25">
                  <input
                    class="form-control form-control-sm"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    formControlName="repeat_interval"
                    value="1"
                  />
                </div>
                <div>
                  {{
                    selectedRepeatType === "daily"
                      ? "day(s)"
                      : selectedRepeatType === "weekly"
                        ? "week(s) on"
                        : "month(s) on"
                  }}
                </div>
              </div>
            </div>
          }
          @if (selectedRepeatType === "weekly") {
            <div class="col-12">
              <dl>
                <dt>Select WeekDays</dt>
                <dd>
                  <div class="d-flex column-gap-5 row-gap-4 flex-wrap p-3">
                    @for (
                      day of [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday",
                        "Sunday",
                      ];
                      track day;
                      let i = $index
                    ) {
                      <div>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="selectedDays?.includes(day)"
                          (change)="selectWeekDays(day)"
                          id="check-{{ i }}"
                        />
                        <label
                          class="form-check-label ms-1"
                          for="check-{{ i }}"
                        >
                          {{ day }}
                        </label>
                      </div>
                    }
                  </div>
                </dd>
              </dl>
            </div>
          }
          @if (selectedRepeatType === "monthly") {
            <div
              class="form-floating col-12"
              (click)="changeMonthType('day')"
              [ngClass]="selectedMonthType === 'day' ? '' : 'month-type'"
            >
              <dl>
                <dt>Select Days of Month</dt>
                <dd>
                  <div class="row row-cols-5">
                    @for (aDay of availabledays; track aDay; let i = $index) {
                      <div class="mt-3">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [checked]="selectedDays?.includes(aDay)"
                          (change)="selectWeekDays(aDay)"
                          id="check-{{ i }}"
                        />
                        <label
                          class="form-check-label ms-1"
                          for="check-{{ i }}"
                        >
                          {{ aDay }}
                        </label>
                      </div>
                    }
                  </div>
                </dd>
              </dl>
            </div>
            <div class="text-center font-weight-bold col-12">OR</div>
            <div
              class="col-12 row row-cols-1 g-2"
              (click)="changeMonthType('date')"
              [ngClass]="selectedMonthType === 'date' ? '' : 'month-type'"
            >
              <div class="form-floating col-12">
                <select
                  class="form-control"
                  id="positionSelect"
                  formControlName="position"
                  (change)="updateRepeatDetails()"
                >
                  @for (freq of frequencyDetails; track freq) {
                    <option [value]="freq.value">
                      {{ freq.name | titlecase }}
                    </option>
                  }
                </select>
                <label for="positionSelect">Select Position</label>
              </div>
              <div class="form-floating col-12">
                <select
                  class="form-control"
                  id="weekDaySelect"
                  formControlName="week_day"
                  (change)="updateRepeatDetails()"
                >
                  @for (
                    day of [
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ];
                    track day
                  ) {
                    <option [value]="day">
                      {{ day }}
                    </option>
                  }
                </select>
                <label for="weekDaySelect">Select Week Day</label>
              </div>
            </div>
          }
        </div>
      }
      @if (errorMessage && !schedulerForm.valid) {
        <div
          class="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {{ errorMessage }}
        </div>
      } @else if (schedulerForm.value | misc: "shiftSummary") {
        <div
          class="mb-4 alert pe-4 ps-3"
          id="repeat-description"
          [ngClass]="shownFrom == 'schedule' ? '' : 'fs-5'"
        >
          {{ schedulerForm.value | misc: "shiftSummary" }}
        </div>
      }

      @if (dialogBox) {
        <div class="row row-cols-2 mt-4">
          <div class="col">
            <button
              class="btn btn-lg btn-dark w-100"
              (click)="onCloseDialogue()"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              class="btn btn-lg btn-primary w-100"
              (click)="submitSchedule()"
              [disabled]="!schedulerForm.valid"
            >
              Save
            </button>
          </div>
        </div>
      }
    </form>
  </div>
</div>
